<style lang="less" scoped>
  .day-column-title {
    height: 51px;
    line-height: 50px;
    border-bottom: 1px solid #e3e3e3;
    background-color: #f7f7f7;
    font-size: 15px;
    color: #808080;
    text-align: center;
  }
  .product-add-button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
    max-height: calc(100% - 51px);
  }
  .product-add-button {
    width: 40px;
    height: 40px;
    background-image: url(~@/assets/icon-add.png);
    background-size: cover;
    background-repeat: no-repeat;
  }
  .product-item-wrapper {
    max-width: 230px;
    margin: 10px 20px;
  }
</style>

<template lang="pug">
  section.best-product
    p.day-column-title {{ this.week[this.idx] }}
    .product-item-wrapper(v-for="(product, index) in products", :key="product.prodSeq")
      product-item(
        :product="product",
        :categories="categories",
        :noPadding="true",
        :edit="edit",
        :del="true",
        :index="index",
        @delete="deleteBestProduct",
      )
    .product-add-button-wrapper(v-if="products.length < 3")
      button.product-add-button(@click="showProductList")
</template>

<script>
import { mapState } from 'vuex';
import ProductItem from '@/components/ProductItem.vue';

export default {
  computed: {
    ...mapState({
      me: state => state.me,
      categories: state => state.categories,
    }),
  },

  props: {
    products: {
      type: Array,
      default: () => ([]),
    },
    idx: {
      type: Number,
      default: 0,
    },
  },

  components: {
    ProductItem,
  },

  methods: {
    // BEST 상품 삭제
    deleteBestProduct(product, index) {
      this.$emit('deleteBestProduct', product, index);
    },

    // 상품 리스트
    showProductList() {
      this.$emit('showProductList', this.idx);
    },
  },
  data() {
    return {
      edit: false,
      week: ['월', '화', '수', '목', '금', '토', '일'],
    };
  },
};
</script>
